import AccountReconciliation from './index';

export default {
    path: '/home/balance/center/account/reconciliation',
    component: AccountReconciliation
};